import { getWrapper } from './axios'

export const getCountries = (): Promise<{ code: string; name: string }[]> => {
    return getWrapper('/list/countries') as Promise<{ code: string; name: string }[]>
}

export const getRegions = (params: { country: string }): Promise<{ code: string; name: string }[]> => {
    return getWrapper('/list/regions', { params }) as Promise<{ code: string; name: string }[]>
}
